import { render, staticRenderFns } from "./AscMxRecRecommendationWrapper.vue?vue&type=template&id=74c2f647&"
import script from "./AscMxRecRecommendationWrapper.vue?vue&type=script&lang=js&"
export * from "./AscMxRecRecommendationWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscMxRecRecommendationWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports